/* vw-cart.js — Kaufbuttons der Ratgeberseiten: Absicherung + Messung (17.08.2026)
 *
 * ZWEI PROBLEME, DIE DIESE DATEI LOEST
 *
 * 1) ROBUSTHEIT. Der Handler fuer [data-vw-add] lag als <script> IM SEITEN-BODY
 *    der Grounding-Seite /pages/perche-dormire-a-terra-e-salutare. Der Shopify-
 *    Editor loescht <style>/<script> beim Speichern (dieselbe Panne traf am
 *    14.08.2026 die Bioverfuegbarkeits-Seite). Auf der Seite mit rund 70 % aller
 *    Shop-Sitzungen waere der Kaufbutton beim naechsten Bearbeiten lautlos tot
 *    gewesen — ohne Fehlermeldung. Der Handler liegt jetzt hier im Theme.
 *
 * 2) MESSUNG. Kein einziger Ajax-Kaufbutton hat je add_to_cart gemeldet. Der
 *    GA4-Funnel zeigte fuer die Grounding-Seite tagelang 0 Warenkoerbe, obwohl
 *    die Buttons funktionieren. Niemand konnte sehen, ob die staerkste Seite
 *    des Shops verkauft.
 *
 * WARUM DIE MESSUNG AM fetch HAENGT UND NICHT AN DEN BUTTONS
 * Die fuenf uebrigen Ratgeberseiten (zanzare, cirmolo-o-pino-mugo, menta,
 * limone-vs-litsea, sauna) bringen ihren EIGENEN Inline-Handler mit, jeweils mit
 * FEST EINPROGRAMMIERTEM Erfolgstext in der Sprache der Seite ("Nel carrello",
 * "Im Warenkorb", ...). Wuerde dieses Skript sie uebernehmen, gingen die
 * deutschen und englischen Beschriftungen verloren. Stattdessen wird window.fetch
 * einmal umhuellt: Jeder erfolgreiche POST auf /cart/add.js meldet add_to_cart —
 * egal welcher Handler ihn ausgeloest hat. Kein Eingriff in bestehendes Verhalten.
 *
 * WARUM gtag DER RICHTIGE KANAL IST
 * Der Shop laedt weder GTM noch gtag.js im Quelltext; in einem Browser ohne
 * Cookie-Zustimmung ist window.gtag ueberall undefined. Trotzdem kommt cta_click
 * in GA4 an (82 Events in 3 Tagen, korrekt der Seite zugeordnet) — Google wird
 * also nach erteilter Zustimmung nachgeladen. add_to_cart nimmt denselben Weg.
 * Zusaetzlich gehen die Events an dataLayer und Clarity, wie beim cta_click-Tracker.
 *
 * NUR AUF page-TEMPLATES EINGEBUNDEN. Auf Produktseiten meldet Shopify
 * add_to_cart selbst — dort wuerde diese Datei doppelt zaehlen.
 */
(function () {
  'use strict';

  function device() {
    return (window.matchMedia && window.matchMedia('(max-width: 560px)').matches)
      ? 'mobile' : 'desktop';
  }

  /* ------------------------------------------------------------------ Messung */

  function trackAdd(item) {
    item = item || {};
    var vid = item.variant_id || item.id || '';
    var name = item.product_title || item.title || 'unbekannt';
    var qty = item.quantity || 1;
    var val = (typeof item.price === 'number') ? item.price / 100 : undefined;
    var items = [{ item_id: String(vid), item_name: name, quantity: qty, price: val }];
    var payload = {
      currency: 'EUR', value: val,
      vw_quelle: window.location.pathname, vw_device: device(), items: items
    };
    try {
      if (window.clarity) {
        clarity('event', 'add_to_cart');
        clarity('set', 'add_to_cart_quelle', window.location.pathname);
      }
    } catch (e) {}
    try {
      var dl = (window.dataLayer = window.dataLayer || []);
      dl.push({
        event: 'add_to_cart', currency: 'EUR', value: val,
        vw_quelle: payload.vw_quelle, vw_device: payload.vw_device, items: items
      });
    } catch (e) {}
    try {
      if (typeof window.gtag === 'function') gtag('event', 'add_to_cart', payload);
    } catch (e) {}
  }

  /* window.fetch einmal umhuellen. Faengt JEDEN Ajax-Kauf auf dieser Seite ab,
     unabhaengig davon, welcher Handler ihn ausgeloest hat. */
  if (!window.__vwFetchWrapped && typeof window.fetch === 'function') {
    window.__vwFetchWrapped = true;
    var echt = window.fetch;
    window.fetch = function (eingabe, optionen) {
      var url = '';
      try { url = (typeof eingabe === 'string') ? eingabe : (eingabe && eingabe.url) || ''; } catch (e) {}
      var istKauf = url.indexOf('/cart/add') !== -1;
      var p = echt.apply(this, arguments);
      if (!istKauf) return p;
      return p.then(function (antwort) {
        try {
          if (antwort && antwort.ok) {
            antwort.clone().json().then(function (d) {
              if (!d) return;
              if (d.items && d.items.length) d.items.forEach(trackAdd);
              else trackAdd(d);
            }).catch(function () {});
          }
        } catch (e) {}
        return antwort;
      });
    };
  }

  /* ------------------------------------------- Kaufbutton [data-vw-add] */

  function onAdd(e) {
    var btn = e.currentTarget;
    if (btn.disabled) return;
    var id = parseInt(btn.getAttribute('data-vw-add'), 10);
    if (!id) return;

    btn.disabled = true;
    btn.style.opacity = '.6';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: id, quantity: 1 })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function () {
        var ok = btn.getAttribute('data-vw-oklabel');
        var ziel = btn.getAttribute('data-vw-checkout');
        if (ok && ziel) {
          var a = document.createElement('a');
          a.className = 'vw-button--cart-done';
          a.href = ziel;
          a.textContent = ok;
          a.setAttribute('data-vw-cta', 'kit_base_ajax_done');
          btn.parentNode.replaceChild(a, btn);
        } else {
          btn.disabled = false;
          btn.style.opacity = '';
        }
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      })
      .catch(function () {
        var fb = btn.getAttribute('data-vw-fallback');
        if (fb) { window.location.href = fb; return; }
        btn.disabled = false;
        btn.style.opacity = '';
      });
  }

  /* Der Klon trennt einen evtl. noch vorhandenen Inline-Listener ab, damit der
     Artikel nicht DOPPELT im Warenkorb landet. Gefahrlos: cta_click haengt
     delegiert am document und ueberlebt den Tausch, direkte Listener hat auf
     diesen Buttons sonst niemand. */
  function bind() {
    var liste = document.querySelectorAll('[data-vw-add]');
    for (var i = 0; i < liste.length; i++) {
      var btn = liste[i];
      if (btn.getAttribute('data-vw-bound')) continue;
      var klon = btn.cloneNode(true);
      klon.setAttribute('data-vw-bound', '1');
      klon.disabled = false;
      klon.style.opacity = '';
      btn.parentNode.replaceChild(klon, btn);
      klon.addEventListener('click', onAdd);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
  document.addEventListener('cart:refresh', function () { setTimeout(bind, 300); });
})();
